
<!-- Carousel -->
   <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig" *ngIf="featuredImages.length">
      <div ngxSlickItem *ngFor="let image of featuredImages" class="slide" style="width: 100%;">
            <img src="https://s3-us-west-1.amazonaws.com/zenfoods/features/web/{{image.zf_image_web}}" width="100%" height="50%">
      </div>
  </ngx-slick-carousel>
<!-- Carousel -->

<!-- Categories -->
<div class="col-10 p-0 categories-bg">
  <div class="category-bg p-0 animated fadeIn"
       *ngFor="let category of categories"
       routerLink="/items/{{category.zf_id}}/{{ replaceSpecialChars(category.zf_name) | lowercase}}">
    <div class="imageBg">
      <img src="{{environment.s3categoryImageLarge}}{{category.zf_image_web}}">
    </div>
    <div class="category-detail-bg">
      <h2 class="mb-1">{{category.zf_name}}</h2>
      <p class="m-0" *ngIf="category.zf_usage_count >= 2">{{category.zf_usage_count}} Items</p>
      <p class="m-0" *ngIf="category.zf_usage_count <= 1">{{category.zf_usage_count}} Item</p>
    </div>
  </div>
</div>
<!-- Categories -->



// WEBPACK FOOTER //
// ./src/app/modules/home/home.component.html